export const FETCH_AVAILABILITY = "FETCH_AVAILABILITY"
export const SEARCH_TRAINS = "SEARCH_TRAINS"
export const SET_BIZ_USER_INFO = "SET_BIZ_USER_INFO"
export const SET_SEARCH_DATA = "SET_SEARCH_DATA"
export const APPLY_FILTER = "APPLY_FILTER"
export const SORT_SELECTED = "SORT_SELECTED"
export const ACTION_SET_CONFIRM_OPTIONS = "ACTION_SET_CONFIRM_OPTIONS"
export const ACTION_INIT_RAILS_LISTING_FILTERS = "ACTION_INIT_RAILS_LISTING_FILTERS"
export const ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE = "ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE"
export const FETCH_AVAILABILITY_SET_LOADER = "FETCH_AVAILABILITY_SET_LOADER"
export const FETCH_AVAILABILITY_SET_ERROR = "FETCH_AVAILABILITY_SET_ERROR"
export const ACTION_FETCH_ALTERNATE_AVAILIBILITY="ACTION_FETCH_ALTERNATE_AVAILIBILITY"
export const FILLING_TRAINS_QUERY_DATA="FILLING_TRAINS_QUERY_DATA"
export const FETCH_AVAILABILITY_REMOVE_ERROR="FETCH_AVAILABILITY_REMOVE_ERROR"
export const CONFIRMATION_PROBABILITY = '@mmt/CONFIRMATION_PROBABILITY';
export const DEFAULT_SORT_SELECTED = "DEFAULT_SORT_SELECTED";
export const CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY = "CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY";
export const MYBIZ_REQUISITION_FLOW = "@rails/MYBIZ_REQUISITION_FLOW";